/* Content-editor HTML may contain empty/spacer headings. Preserve spacing without announcing an empty heading. */
(() => {
  const editorialSelector = '[data-a11y-editorial-copy]';
  function improveContent(root) {
    for (const heading of root.querySelectorAll('h1,h2,h3,h4,h5,h6')) {
      if (heading.dataset.a11yChecked) continue;
      heading.dataset.a11yChecked = 'true';
      if (!heading.textContent.replace(/\u00a0/g, '').trim() && !heading.querySelector('img,svg,video,input,button')) {
        const spacer = document.createElement('div');
        // These are genuinely empty content-editor headings, not information hidden from a scanner.
        spacer.className = heading.className;
        spacer.style.cssText = heading.style.cssText;
        spacer.innerHTML = heading.innerHTML;
        heading.replaceWith(spacer);
      } else if (root.matches(editorialSelector)) {
        // Keep the editorial typography while exposing each independent section heading at level 2.
        heading.setAttribute('aria-level', '2');
      }
    }
  }
  function start() {
    for (const root of document.querySelectorAll(`${editorialSelector},[data-a11y-page-content]`)) {
      improveContent(root);
      new MutationObserver(() => improveContent(root)).observe(root, {childList: true, subtree: true});
    }
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      for (const video of document.querySelectorAll('video[autoplay]')) {
        video.pause();
        video.removeAttribute('autoplay');
        video.controls = true;
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
